import React, { useContext, useEffect, useRef, useState } from 'react'

import { toast } from 'react-toastify'
import { useQuery } from 'react-query'

import { Icon } from '../../../components/Icon'
import { IncidentsHeadersAdmin } from '../../../data/index'
import Menu from '../../../components/UI/UIMenu'
import Modal from '../../../components/UI/UIModal'
import UITextArea from '../../../components/UI/UITextArea'
import UISubHeaderComponent from '../../../components/UI/UISubHeaderComponent'
import '../../../App.css'
import UiSelect from '../../../components/UI/UISelect'
import UIButton from '../../../components/UI/UIButton'
import {
  ErrorResponse,
  NoteApiResponse,
  incidentData,
} from '../../../utils/types'
import {
  createIncident,
  createIncidentInvitation,
  createNotes,
  deleteIncident,
  deleteIncidentInvitation,
  getNotes,
  updateIncident,
  updateIncidentStatus,
} from '../../../api/lead/incidents'
import Loading from '../../../components/UI/Loading'
import {
  checkValidation,
  getActionMessage,
  handleDownloadPdf,
  SeverityIcon,
} from './utils'
import {
  getAllCandidates,
  getAllInvolvedUsers,
  getAllUsersInvited,
  getIncidentData,
  getIncidentDataById,
} from './apiCalls'
import {
  capitalizeFirstLetter,
  formatDate,
  statusBgColorWhistleblowing,
} from '../../../utils/utils'
import UITextInput from '../../../components/UI/UITextInput'
import ButtonMenue from '../../../components/UI/ButtonMenue'
import { SidebarContext } from '../../../context/SidebarContext'

interface incidents {
  Report_No: number
  Status: string
  Severity_Level: string
  Incident_concerning: string
  Name_of_Employer: string
  Date_Reported: string
  Updated_At: string
  Created_By: string
  Updated_By: string
}

export interface FormData {
  candidate: string
  employer: string
  severity_level: string
  overview: string
  status: string
  receivedDate?: string
  receivedBy?: string

  supportRequirementRating?: string
  immediateActionTaken?: string
  furtherActionRequired?: string
  monitoringRequired?: string
  conclusionOfOutcome?: string
}
const initialData = {
  candidate: '',
  employer: '',
  severity_level: '',
  overview: '',
  status: 'open',
  immediateActionTaken: '',
  furtherActionRequired: '',
  monitoringRequired: '',
  conclusionOfOutcome: '',
}
const IncidentLead = () => {
  const wrapperRefNotificationMenu = useRef<HTMLDivElement>(null)
  const { viewBool, setViewBool } = useContext(SidebarContext)

  const [formData, setFormData] = useState<FormData | incidentData>(initialData)
  const pdfRef = useRef<HTMLDivElement>(null)
  const [id, setId] = useState('')
  const [sId, setSId] = useState('')
  const [isExportOpen, setIsExportOpen] = useState<boolean>(false)
  const [isConfrim, setIsConfrim] = useState<boolean>(false)
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenStatus, setIsOpenStatus] = useState(false)

  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [isOpenInvite, setIsOpenInvite] = useState(false)
  const [isOpenMenuButton, setIsOpenMenuButton] = useState(false)
  const [viewPermission, setViewPermissions] = useState('Yes')
  const [editPermission, setEditPermissions] = useState('No')
  const [deletePermission, setDeletePermissions] = useState('No')
  const [isView, setIsView] = useState(viewBool)
  const [isEdit, setIsEdit] = useState(false)
  const [userId, setUserId] = useState('')
  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [status, setStatus] = useState('')
  const [sortBy, setSortBy] = useState<string>('reportNo')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')
  const [isOpenAddNotesModal, setIsOpenAddNotesModal] = useState<boolean>(false)

  const [notesDetails, setNotesDetails] = useState('')
  const [isLoadingAddNotes, setIsLoadingAddNotes] = useState<boolean>(false)
  const [siverity, setSiverity] = useState('')

  const incidents = useQuery('policy', () =>
    getIncidentData(
      // currentPage,
      sortBy,
      sortOrderValue,
      siverity
    )
  )

  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(Number(incidents?.data?.count) || 1000).fill(false)
  )

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  useEffect(() => {
    incidents.refetch() // Refetch incidents when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue, siverity])

  // const handlePageChange = (pageNumber: number): void => {
  //   setCurrentPage(pageNumber)
  //   // You can add additional logic here, like fetching data for the new page
  // }

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const handleOpenModal = () => {
    setIsOpen(true)
    setFormData(initialData)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
    setIsEdit(false)
  }
  const handleStatusOpenModal = () => {
    setIsOpenStatus(true)
  }
  const handleStatusCloseModal = () => {
    setIsOpenStatus(false)
  }
  const handleCloseDeleteModal = () => {
    setIsOpenDelete(false)
  }
  // const handleExportOpenModal = () => {
  //   setIsExportOpen(true)
  // }

  const handleExportCloseModal = () => {
    setIsExportOpen(false)
  }

  const incidentById = useQuery(['incidentById', id], () =>
    getIncidentDataById(id, sId)
  )

  // const policyById = useQuery(['policyById', id], getPolicyDataById)

  const invitedUsers = useQuery(
    ['invitedUsers', id],
    () => getAllUsersInvited(id),
    {
      enabled: !!id, // Only fetch data when id is truthy
    }
  )
  const actionsUsers = useQuery(
    ['involvedUsers', id],
    () => getAllInvolvedUsers(id),
    {
      enabled: !!id, // Only fetch data when id is truthy
    }
  )
  const users = useQuery('users', () => getAllCandidates())

  const handleChange = (fieldName: string, value: string): void => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const createNewIncident = async (): Promise<void> => {
    try {
      const response = (await createIncident(formData)) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        incidents.refetch()
        handleCloseModal()
        setFormData(initialData)
        toast.success('Incident Created.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const removePolicy = async (): Promise<void> => {
    try {
      const response = (await deleteIncident({ id: id })) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        incidents.refetch()
        setIsEdit(false)
        setIsView(false)
        setIsOpenDelete(!isOpenDelete)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }

  function convertNullToEmptyString(obj: FormData): FormData {
    // Create a new object to store the updated values
    const newObj: Partial<FormData> = {}

    // Iterate through the keys of the input object
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const typedKey = key as keyof FormData
        // If the value is null, convert it to an empty string
        // Otherwise, keep the original value
        newObj[typedKey] = obj[typedKey] === null ? '' : obj[typedKey]
      }
    }

    // Return the new object cast back to the original type
    return newObj as FormData
  }

  const editIncident = async (): Promise<void> => {
    try {
      const response = (await updateIncident(
        convertNullToEmptyString(formData),
        id
      )) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        incidents.refetch()
        incidentById.refetch()
        // setIsOpen(!isOpen)
        setIsEdit(false)
        setFormData(initialData)
        toast.success('Incident Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const changeStatus = async (): Promise<void> => {
    const response = (await updateIncidentStatus(
      {
        status: status,
      },
      id
    )) as {
      status?: string
      data: incidentData
    }
    if (response?.status == 'successful') {
      incidents.refetch()
      incidentById.refetch()
      // setIsOpen(!isOpen)
      setIsEdit(false)
      setFormData(initialData)
      toast.success('Status Updated.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const createNewInnitation = async (): Promise<void> => {
    try {
      const response = (await createIncidentInvitation(
        {
          userId: userId,
          viewAccess: viewPermission == 'Yes' ? true : false,
          editAccess: editPermission == 'Yes' ? true : false,
          deleteAccess: deletePermission == 'Yes' ? true : false,
        },
        id
      )) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        invitedUsers.refetch()
        setIsOpenInvite(false)
        toast.success('User Invited.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const removeInvite = async (userId: string): Promise<void> => {
    try {
      const response = (await deleteIncidentInvitation({ id: userId })) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        invitedUsers.refetch()
        toast.success('User Removed', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }

  const userOptions =
    users?.data && Array.isArray(users?.data)
      ? users?.data?.map((item) => ({
          value: item.userId,
          label: item.firstName || 'No-name',
        }))
      : []

  const InvolvedUserOptions =
    actionsUsers?.data && Array.isArray(actionsUsers?.data)
      ? actionsUsers?.data?.map((item) => ({
          value: item?.userId,
          label: item?.firstName || 'No-name',
        }))
      : []

  const notes = useQuery<NoteApiResponse>(
    'notes',
    () => getNotes(id) as unknown as NoteApiResponse,
    {
      enabled: !!id, // Only fetch data when id is truthy
    }
  )

  const addNote = async (): Promise<void> => {
    setIsLoadingAddNotes(true)
    try {
      const response = (await createNotes(
        {
          detail: notesDetails,
          // deetail: notesDetails,
          mentions: [userId],
        },
        id
      )) as {
        status?: string
        data: []
      }
      if (response?.status == 'successful') {
        notes.refetch()
        setIsOpenAddNotesModal(false)
        toast.success('Note added', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while adding note.', {
        position: 'top-right',
      })
    } finally {
      setIsLoadingAddNotes(false)
    }
  }
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      // Check if the click is outside the component
      if (
        wrapperRefNotificationMenu.current &&
        !wrapperRefNotificationMenu.current.contains(event.target as Node)
      ) {
        setIsOpenMenuButton(false) // Close the dropdown if it's open
      }
      if (
        wrapperRefNotificationMenu.current &&
        !wrapperRefNotificationMenu.current.contains(event.target as Node)
      ) {
        setIsOpenMenuButton(false) // Close the dropdown if it's open
      }
    }
    // Add event listener for clicks outside the component
    document.addEventListener('mousedown', handleOutsideClick)
    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])

  useEffect(() => {
    setIsView(viewBool)
  }, [viewBool])

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-8  '
      }
    >
      {!isView && (
        <div className="flex flex-col gap-10 custom-scrollbar w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>Incidents</p>
            </div>

            <div className={'flex flex-row gap-[15px]'}>
              <div
                onClick={() => {
                  handleOpenModal()
                }}
                className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
              >
                <p className={'font-medium text-[14px] text-white'}>
                  Create Report
                </p>
                <Icon
                  name={'IconPlus'}
                  strokeWidth={1}
                  stroke={'white'}
                  width={16}
                  height={16}
                />
              </div>
            </div>
          </div>

          <div className="flex items-center self-start gap-[8px] ">
            <p className={'text-text2 font-semibold text-[14px] '}>Sort by</p>
            <div className="rounded-[40px] bg-gray2 py-2 px-4 flex justify-center items-center gap-1 cursor-pointer">
              <p className={'text-text3 font-medium text-xs leading-5'}>
                {siverity}
              </p>
              <ButtonMenue
                wrapperRefNotificationMenu={wrapperRefNotificationMenu}
                isOpen={isOpenMenuButton}
                items={[
                  {
                    label: 'Serious',
                    onClick: () => {
                      setSiverity('serious')
                    },
                    icon: 'IconAlertCircle',
                    iconColor: '#FF6666',
                  },
                  {
                    label: 'Minor',
                    onClick: () => {
                      setSiverity('minor')
                    },
                    icon: 'IconAlertTriangle',
                    iconColor: '#FFA800',
                  },
                  {
                    label: 'Well Being',
                    onClick: () => {
                      setSiverity('well-being')
                    },
                    icon: 'IconAlertCircle',
                    iconColor: '#02698C',
                  },
                  {
                    label: 'Clear Filter',
                    onClick: () => {
                      setSiverity('')
                    },
                    icon: '',
                    iconColor: '#02698C',
                  },
                ]}
              >
                <div
                  onClick={() => setIsOpenMenuButton(!isOpenMenuButton)}
                  className={`gap-3 border border-gray2 items-center justify-between text-white px-4 py-3 flex rounded-3xl cursor-pointer ${isOpenMenuButton ? 'bg-[#CCE1E8]' : 'bg-transparent'}`}
                >
                  <Icon
                    name={'IconDotsVertical'}
                    strokeWidth={1.2}
                    stroke={'#02698C'}
                    width={16}
                    height={16}
                  />
                </div>
              </ButtonMenue>
            </div>
          </div>
          {/* content container */}

          <div className="relative h-full overflow-y-auto">
            <div className=" max-h-full h-full overflow-y-auto">
              {incidents.isLoading && (
                <div className="flex justify-center items-center h-screen">
                  <Loading size="large" />
                </div>
              )}
              {incidents.isError &&
                incidentById.isError &&
                invitedUsers.isError && (
                  <div className="flex justify-center items-center h-screen">
                    <p>Something went wrong</p>
                  </div>
                )}
              {!incidents.isLoading && !incidents.isError && (
                <div className=" rounded-[16px] ">
                  <table className="min-w-full table-auto divide-y divide-white  ">
                    <thead className="sticky top-0 z-8 mb-4  ">
                      <tr className="bg-gray2 rounded-lg h-10 mb-18">
                        {IncidentsHeadersAdmin?.map((item, index: number) => {
                          return (
                            <th
                              key={index}
                              className={`w-1/8  px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''} ${index === IncidentsHeadersAdmin.length - 1 ? 'border-none' : 'border-r border-white'}`}
                            >
                              <div className="flex items-center">
                                <p className="text-text1 font-semibold text-sm flex-1">
                                  {item.replace(/_/g, ' ')}
                                </p>
                                <div
                                  onClick={() => {
                                    let sortBy = ''
                                    switch (item as keyof incidents) {
                                      case 'Report_No':
                                        sortBy = 'reportNo'
                                        break
                                      case 'Status':
                                        sortBy = 'status'
                                        break
                                      case 'Severity_Level':
                                        sortBy = 'severity_level'
                                        break
                                      case 'Incident_concerning':
                                        sortBy = 'candidate'
                                        break
                                      case 'Name_of_Employer':
                                        sortBy = 'employer'
                                        break
                                      case 'Date_Reported':
                                        sortBy = 'createdAt'
                                        break
                                      case 'Updated_At':
                                        sortBy = 'updatedAt'
                                        break
                                      case 'Created_By':
                                        sortBy = 'createdByFirstName'
                                        break
                                      case 'Updated_By':
                                        sortBy = 'updatedByName'
                                        break
                                      default:
                                        break
                                    }
                                    handleSort(sortBy)
                                  }}
                                >
                                  <Icon
                                    name={'IconChevronDown'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1}
                                    stroke={'#67A5B9'}
                                  />
                                </div>
                              </div>
                            </th>
                          )
                        })}
                        {/* <th className="w-[56px] rounded-r-lg"></th> */}
                        <th className="w-1/8 px-4 py-3  text-left  min-w-[56px] rounded-r-lg"></th>
                      </tr>
                    </thead>
                    <tbody className=" pt-72 divide-y divide-white">
                      {incidents?.data?.data?.map((item, index) => (
                        <>
                          <tr className="1  bg-gray1">
                            {/* Example row */}
                            <td className="px-4 text-sm text-text1 leading-6 font-semibold h-[48px] py-2 border border-white">
                              {item?.reportNo}
                            </td>
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <div
                                className={`px-[10px] flex justify-center items-center bg-${statusBgColorWhistleblowing(item.status)} h-[28px] rounded-[100px]`}
                              >
                                <p className="text-xs font-medium leading-5 text-text2">
                                  {capitalizeFirstLetter(item.status || '')}
                                </p>
                              </div>
                            </td>
                            <td className="px-4 min-w-[135px] font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                              <SeverityIcon
                                severity_level={item.severity_level}
                              />
                            </td>
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <p className="text-sm text-text1 leading-6 font-semibold">
                                {item.candidate}
                              </p>
                            </td>
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <p className="text-sm text-text1 leading-6 font-semibold">
                                {item.employer}
                              </p>
                            </td>
                            <td className="px-4 text-sm text-text1 leading-6 font-semibold h-[48px] py-2 border border-white">
                              {formatDate(item?.createdAt || '')}
                            </td>

                            <td className="px-4 text-sm text-text1 leading-6 font-semibold h-[48px] py-2 border border-white">
                              <p className="text-sm text-text1 leading-6 font-semibold">
                                {item?.createdByFirstName}{' '}
                                {item?.createdByLastName}
                              </p>
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              {item.updatedBy != null ? (
                                <p className="text-sm text-text1 leading-6 font-semibold">
                                  {formatDate(item?.updatedAt || '')}
                                </p>
                              ) : (
                                <p className="text-sm text-text1 leading-6 font-semibold"></p>
                              )}
                            </td>
                            <td className="px-4 text-sm text-text1 leading-6 font-semibold h-[48px] py-2 ">
                              <p className="text-sm text-text1 leading-6 font-semibold">
                                {item.updatedByName}
                              </p>
                            </td>
                            <td className="px-4 items-center justify-center flex relative  h-[48px] py-2">
                              <Menu
                                isOpen={isOpenMenu[index]}
                                items={[
                                  {
                                    label: 'View',
                                    onClick: () => {
                                      handleToggleMenu(index)
                                      setIsView(true)
                                      setViewBool(true)
                                      setSId(item?.schoolId || '')
                                      setId(item.id)
                                    },
                                    icon: 'IconEye',
                                    iconColor: '',
                                  },
                                  {
                                    label: 'Edit',
                                    onClick: () => {
                                      handleToggleMenu(index)

                                      setId(item.id)
                                      setIsOpen(true)
                                      setIsEdit(true)
                                      setFormData({
                                        candidate: item?.candidate,
                                        employer: item?.employer,
                                        severity_level: item?.severity_level,
                                        overview: item?.overview,
                                        status: item?.status,

                                        supportRequirementRating:
                                          item.supportRequirementRating,
                                        immediateActionTaken:
                                          item.immediateActionTaken,
                                        furtherActionRequired:
                                          item.furtherActionRequired,
                                        monitoringRequired:
                                          item.monitoringRequired,
                                        conclusionOfOutcome:
                                          item.conclusionOfOutcome,
                                      } as FormData)
                                    },
                                    icon: 'IconEdit',
                                    iconColor: '',
                                  },

                                  {
                                    label: 'Remove',
                                    onClick: () => {
                                      handleToggleMenu(index)
                                      // setIsView(true)
                                      setIsOpenDelete(true)
                                      setId(item.id)
                                    },
                                    icon: 'IconTrash',
                                    iconColor: '#FF6666',
                                    textColor: 'text-textError',
                                  },
                                ]}
                                type={'table'}
                                setIsOpenMenu={setIsOpenMenu}
                                isOpenMenus={isOpenMenu}
                              >
                                <div
                                  className="cursor-pointer"
                                  onClick={() => handleToggleMenu(index)}
                                >
                                  <Icon
                                    name={'IconDotsVertical'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1.5}
                                    stroke={'#02698C'}
                                  />
                                </div>
                              </Menu>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {isView && (
        <div
          ref={pdfRef}
          className=""
          style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}
        >
          <div className="flex justify-between">
            <UISubHeaderComponent
              mainPage="Incidents"
              subPage={`Incident Report No. ${incidentById.data?.data?.reportNo}`}
              copy=""
              // onPublish={handleOpenModal}

              onBack={() => {
                setIsView(false)
              }}
              isViewMode={true}
            />

            {/* content container */}
            <div className="flex gap-3">
              <div
                onClick={() => {
                  setIsView(false)
                }}
                className="gap-3 bg-gray1 items-center justify-between text-white px-5 py-3 flex rounded-3xl cursor-pointer"
              >
                <Icon
                  name={'IconArrowLeft'}
                  strokeWidth={1.2}
                  stroke={'white'}
                  width={16}
                  height={16}
                />
                <p className={'font-semibold text-sm leading-6 text-text1'}>
                  Back
                </p>
              </div>
              <div
                onClick={() => handleDownloadPdf(pdfRef)}
                className="gap-3 bg-bluishGreen items-center justify-between text-white px-5 py-3 flex rounded-3xl cursor-pointer"
              >
                <p className={'font-semibold text-sm leading-6 text-white'}>
                  Export
                </p>
                <Icon
                  name={'IconShare'}
                  strokeWidth={1.2}
                  stroke={'#FFFFFF'}
                  width={16}
                  height={16}
                />
              </div>
              <ButtonMenue
                wrapperRefNotificationMenu={wrapperRefNotificationMenu}
                isOpen={isOpenMenuButton}
                items={[
                  {
                    label: 'Edit',
                    onClick: () => {
                      handleOpenModal()
                      setIsEdit(true)
                      if (incidentById?.data) {
                        delete incidentById?.data?.data?.candidateName
                        delete incidentById?.data?.data?.candidateId
                        delete incidentById?.data?.data?.schoolName
                        delete incidentById?.data?.data?.schoolId
                        delete incidentById?.data?.data?.isDeleted
                        delete incidentById?.data?.data?.createdBy
                        delete incidentById?.data?.data?.updatedByName
                        delete incidentById?.data?.data?.createdByName
                        delete incidentById?.data?.data
                          ?.supportRequirementRating

                        delete incidentById?.data?.data?.immediateActionTaken
                        delete incidentById?.data?.data?.furtherActionRequired
                        delete incidentById?.data?.data?.monitoringRequired
                        delete incidentById?.data?.data?.conclusionOfOutcome
                        delete incidentById?.data?.data?.closeDate
                        delete incidentById?.data?.data?.createdAt

                        delete incidentById?.data?.data?.reportNo
                        delete incidentById?.data?.data?.updatedAt
                        delete incidentById?.data?.data?.updatedBy

                        setFormData(incidentById?.data?.data as FormData)
                      }
                    },
                    icon: 'IconEdit',
                    iconColor: '#02698C',
                  },
                  {
                    label: 'Change Status',
                    onClick: () => {
                      handleStatusOpenModal()
                      setIsEdit(false)
                      setStatus(incidentById?.data?.data?.status || '')
                    },
                    icon: 'IconPauseCircle',
                    iconColor: '#02698C',
                  },
                  {
                    label: 'Invite',
                    onClick: () => {
                      setIsOpenInvite(true)
                      // setIsOpenDocumentModal(!isOpenDocumentModal)
                    },
                    icon: 'IconUploadCloud',
                    iconColor: '#02698C',
                  },
                  {
                    label: 'Add Action',
                    onClick: () => setIsOpenAddNotesModal(true),
                    icon: 'IconStickerSquare',
                    iconColor: '#02698C',
                  },
                  {
                    label: 'Delete',
                    onClick: () => {
                      setIsOpenDelete(true)
                    },
                    icon: 'IconTrash',
                    iconColor: '#FF6666',
                    textColor: 'text-textError',
                  },
                ]}
              >
                <div
                  onClick={() => setIsOpenMenuButton(!isOpenMenuButton)}
                  className={`gap-3 border border-gray2 items-center justify-between text-white px-4 py-3 flex rounded-3xl cursor-pointer ${isOpenMenuButton ? 'bg-[#CCE1E8]' : 'bg-transparent'}`}
                >
                  <Icon
                    name={'IconDotsVertical'}
                    strokeWidth={1.2}
                    stroke={'#02698C'}
                    width={16}
                    height={16}
                  />
                </div>
              </ButtonMenue>
            </div>
          </div>

          {/* content container */}

          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Report ID
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentById.data?.data?.reportNo}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Status
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div
                      className={`px-4 py-3 w-fit flex justify-center items-center bg-${statusBgColorWhistleblowing(incidentById?.data?.data?.status)} h-[28px] rounded-[100px]`}
                    >
                      <p className="text-xs font-medium leading-5 text-text2">
                        {capitalizeFirstLetter(
                          incidentById.data?.data?.status || ''
                        )}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Severity level
                  </td>
                  <td className="px-4 text-goldYellow font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <SeverityIcon
                      severity_level={
                        incidentById.data?.data?.severity_level
                          ? incidentById.data?.data?.severity_level
                          : ''
                      }
                    />
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Incident Concerning
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className=" px-[20px] rounded-[10px] gap-[5px] w-fit py-[10px] bg-gray2 flex justify-center items-center">
                      <Icon
                        name={'IconUserCircle'}
                        strokeWidth={1}
                        stroke={'#02698C'}
                        width={16}
                        height={16}
                      />
                      <p> {incidentById.data?.data?.candidate}</p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Name of Employer
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className=" px-[20px] rounded-[10px] gap-[5px] w-fit py-[10px] bg-gray2 flex justify-center items-center">
                      <Icon
                        name={'IconBuilding'}
                        strokeWidth={2}
                        stroke={'#02698C'}
                        width={26}
                        height={26}
                      />
                      <p>{incidentById?.data?.data?.employer}</p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] min-h-[48px]  py-2 border border-white">
                    {incidentById.data?.data?.overview}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Created By
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className=" px-[20px] rounded-[10px] gap-[5px] w-fit py-[10px] bg-gray2 flex justify-center items-center">
                      <Icon
                        name={'IconUserCircle'}
                        strokeWidth={1}
                        stroke={'#02698C'}
                        width={16}
                        height={16}
                      />
                      <p> {incidentById.data?.data?.createdByName}</p>
                    </div>
                  </td>
                </tr>

                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Date Received
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentById.data?.data?.createdAt?.substring(0, 16)}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Date Reported
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentById.data?.data?.createdAt?.substring(0, 16)}
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated By
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className=" px-[20px] rounded-[10px] gap-[5px] w-fit py-[10px] bg-gray2 flex justify-center items-center">
                      <Icon
                        name={'IconUserCircle'}
                        strokeWidth={1}
                        stroke={'#02698C'}
                        width={16}
                        height={16}
                      />
                      <p> {incidentById.data?.data?.updatedByName}</p>
                    </div>
                  </td>
                </tr>

                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated On
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentById.data?.data?.updatedByName == null
                      ? ''
                      : incidentById.data?.data?.updatedAt?.substring(0, 16)}
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>

          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Support Requirement Rating
                  </td>
                  <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] py-2 border border-white">
                    {incidentById.data?.data?.supportRequirementRating}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Immediate Action Taken
                  </td>
                  <td className="px-4 min-h-[48px] py-2 border flex items-center gap-3 border-white">
                    <p className="text-text3 font-normal text-sm">
                      {incidentById.data?.data?.immediateActionTaken}
                    </p>
                    <Icon
                      name={'IconAlertTriangle'}
                      width={16}
                      height={16}
                      stroke="#67A5B9"
                    />
                  </td>
                </tr>
                <tr className="bg-gray1">
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Further Action Required
                  </td>
                  <td className="px-4 min-h-[48px]  py-2 border flex items-center gap-3 border-white">
                    <p className="text-text3 font-normal text-sm">
                      {incidentById.data?.data?.furtherActionRequired}
                    </p>
                    <Icon
                      name={'IconAlertTriangle'}
                      width={16}
                      height={16}
                      stroke="#67A5B9"
                    />
                  </td>
                </tr>
                <tr className="bg-gray1">
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Monitoring Required
                  </td>
                  <td className="px-4 min-h-[48px]  py-2 border flex items-center gap-3 border-white">
                    <p className="text-text3 font-normal text-sm">
                      {incidentById.data?.data?.monitoringRequired}
                    </p>
                    <Icon
                      name={'IconAlertTriangle'}
                      width={16}
                      height={16}
                      stroke="#67A5B9"
                    />
                  </td>
                </tr>
                <tr className="bg-gray1">
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Conclusion of Outcome
                  </td>
                  <td className="px-4 min-h-[48px]  py-2 border flex items-center gap-3 border-white">
                    <p className="text-text3 font-normal text-sm">
                      {incidentById.data?.data?.conclusionOfOutcome}
                    </p>
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>

          {/* //invitedUsers */}
          <p className={'text-text2 text-[14px] font-semibold'}>
            Invited Users
          </p>
          {invitedUsers.isLoading && <Loading size="small" />}

          {!invitedUsers.isLoading && (
            <div className="overflow-hidden rounded-[16px] w-full my-4">
              <table className="rounded-[16px] overflow-hidden border w-full border-white">
                <tbody>
                  {invitedUsers?.data?.map((item, index) => (
                    <tr key={index} className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        {item.firstName} {item.lastName}
                      </td>
                      <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] py-2 border border-white">
                        {item.createdAt?.substring(0, 16)}
                      </td>
                      <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] py-2 border border-white">
                        <div
                          onClick={() => {
                            removeInvite(item.id)
                          }}
                        >
                          <Icon
                            name={'IconTrash'}
                            strokeWidth={1}
                            stroke={'#02698C'}
                            width={16}
                            height={16}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}

                  {/* Add more rows as needed */}
                </tbody>
              </table>
            </div>
          )}
          {/* Notes */}
          <div>
            <p className={'text-text2 text-[14px] font-semibold'}>
              Incident Logs
            </p>
          </div>
          <div className="overflow-hidden rounded-[16px] w-full my-4">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                {incidentById?.data?.logs?.map((item, index) => (
                  <tr key={index} className="bg-gray1">
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[15%] h-[48px] py-2 border border-white">
                      Updated By
                    </td>
                    <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] w-[15%]  py-2 border border-white">
                      <div className=" px-[20px] rounded-[10px] gap-[5px] w-fit py-[10px] bg-gray2 flex justify-center items-center">
                        <Icon
                          name={'IconUserCircle'}
                          strokeWidth={1}
                          stroke={'#02698C'}
                          width={16}
                          height={16}
                        />
                        <p> {item.createdByName}</p>
                      </div>
                    </td>
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[15%] h-[48px] py-2 border border-white">
                      Updated On
                    </td>
                    <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] w-[15%] py-2 border border-white">
                      {item.updatedAt.substring(0, 16)}
                    </td>
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[15%] h-[48px] py-2 border border-white">
                      Action Taken
                    </td>
                    <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] w-[15%] py-2 border border-white">
                      {getActionMessage(item.logType)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* notes */}

          <div>
            <p className={'text-text2 text-[14px] font-semibold'}>Notes</p>
          </div>
          <div className="overflow-hidden rounded-[16px] w-full my-4">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                {notes?.data?.data?.data?.map((item, index) => (
                  <tr key={index} className="bg-gray1">
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[15%] h-[48px] py-2 border border-white">
                      Details
                    </td>
                    <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] w-[15%] py-2 border border-white">
                      {item.detail}
                    </td>

                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[15%] h-[48px] py-2 border border-white">
                      Created By
                    </td>
                    <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] w-[15%]  py-2 border border-white">
                      <p> {item.createdByName}</p>
                    </td>
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[15%] h-[48px] py-2 border border-white">
                      Created at
                    </td>
                    <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] w-[15%]  py-2 border border-white">
                      <p> {item.createdAt?.substring(0, 16)}</p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Add Notes Modal */}
      <Modal
        customStyle={{
          borderRadius: 16,
          padding: '20px 16px',
          width: '480px',
        }}
        isOpen={isOpenAddNotesModal}
        onClose={() => {
          setIsOpenAddNotesModal(false)
        }}
      >
        <div
          className={
            'max-h-[80vh] min-h-[45vh] items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => {
              setIsOpenAddNotesModal(false)
            }}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconStickerSquare'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-lg font-bold leading-6'}>
              {'Add Action'}
            </h1>
            <p className={'text-sm leading-5 text-text1 font-normal'}>
              {'Please enter the details about this action'}
            </p>
          </div>
          <div className="w-full flex-col flex gap-4 mt-3">
            <div>
              <UITextArea
                label="Action Details*"
                placeholder="Write action details here"
                rows={7}
                value={notesDetails}
                onChange={(e) => {
                  setNotesDetails(e.target.value)
                }}
              />
            </div>

            <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
              <UiSelect
                onChange={(e) => {
                  setUserId(e)
                }}
                // value={formData.status}
                options={InvolvedUserOptions || []}
                title={'User'}
                placeholder={'Select User'}
              />
            </div>
          </div>
          <div className="w-full mt-4">
            <UIButton
              loading={isLoadingAddNotes}
              onClick={addNote}
              label={'Add'}
            />
          </div>
        </div>
      </Modal>

      {/* modal */}
      <Modal
        customStyle={{ width: '95%', height: '95%' }}
        isOpen={isOpen}
        onClose={handleCloseModal}
      >
        <div
          className={
            'max-h-[90vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              {isEdit ? 'Edit Incident Report' : 'Create Incident Report'}
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please enter the details of the incident
            </p>
          </div>
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
            {/* <UiSelect
              options={[
                { value: 'Report1', label: 'Report1' },
                { value: 'Report2', label: 'Report2' },
              ]}
              title={'Report Name'}
            /> */}
            <div className="w-[25%] ">
              <UiSelect
                onChange={(e) => {
                  handleChange('status', e)
                }}
                value={formData.status}
                options={[
                  { value: 'open', label: 'open' },
                  { value: 'closed', label: 'closed' },
                ]}
                title={'Status'}
              />
            </div>

            <div className="w-[25%]  ">
              <UITextInput
                placeholder={''}
                label={'Incident Concerning*'}
                iconName={''}
                onChange={(e) => {
                  handleChange('candidate', e.target.value)
                }}
                value={formData.candidate}
              />
            </div>
            <div className="w-[25%]  ">
              <UITextInput
                placeholder={''}
                label={'Name of Employer*'}
                iconName={''}
                onChange={(e) => {
                  handleChange('employer', e.target.value)
                }}
                value={formData.employer}
              />
            </div>
            <div className="w-[25%]  ">
              <UiSelect
                onChange={(e) => {
                  handleChange('severity_level', e)
                }}
                value={formData.severity_level}
                options={[
                  { value: 'minor', label: 'minor' },
                  { value: 'serious', label: 'serious' },
                  { value: 'well-being', label: 'well-being' },
                ]}
                title={'Severity Level*'}
              />
            </div>
          </div>

          <UITextArea
            label={'Overview of Concern*'}
            onChange={(e) => {
              handleChange('overview', e.target.value)
            }}
            rows={5}
            value={formData.overview}
            onBlur={() => {}}
            placeholder="Please enter your Description"
            iconName={'none'}
          />

          <div className="w-full flex-col flex gap-4 mt-[10px]">
            <div className="w-[30%]">
              <UiSelect
                onChange={(e) => {
                  handleChange('supportRequirementRating', e)
                }}
                value={formData?.supportRequirementRating}
                options={[
                  {
                    value: 'No further action required',
                    label: 'No further action required',
                  },
                  {
                    value: 'Safeguarding referral required to external agency',
                    label: 'Safeguarding referral required to external agency',
                  },
                  {
                    value: 'Prevent referral required',
                    label: 'Prevent referral required',
                  },
                  {
                    value: 'Urgent action required',
                    label: 'Urgent action required',
                  },
                  {
                    value: 'Monitoring required only',
                    label: 'Monitoring required only',
                  },
                ]}
                placeholder="Select"
                title={'Support Requirement Rating*'}
              />
            </div>
            <UITextArea
              rows={5}
              label={'Immediate Action Taken'}
              onChange={(e) => {
                handleChange('immediateActionTaken', e.target.value)
              }}
              value={formData.immediateActionTaken}
              onBlur={() => {}}
              placeholder="Not specified"
              iconName={'none'}
            />
            <UITextArea
              rows={5}
              label={'Further Action Required'}
              onChange={(e) => {
                handleChange('furtherActionRequired', e.target.value)
              }}
              value={formData.furtherActionRequired}
              onBlur={() => {}}
              placeholder="Not specified"
              iconName={'none'}
            />
            <UITextArea
              rows={5}
              label={'Monitoring Required'}
              onChange={(e) => {
                handleChange('monitoringRequired', e.target.value)
              }}
              value={formData.monitoringRequired}
              onBlur={() => {}}
              placeholder="Not specified"
              iconName={'none'}
            />
            <UITextArea
              rows={5}
              label={'Conclusion of Outcome'}
              onChange={(e) => {
                handleChange('conclusionOfOutcome', e.target.value)
              }}
              value={formData.conclusionOfOutcome}
              onBlur={() => {}}
              placeholder="Not specified"
              iconName={'none'}
            />
          </div>

          {/* other information */}

          {isEdit ? (
            <button
              onClick={() => {
                editIncident()
                handleCloseModal()
              }}
              className="bg-bluishGreen text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px]"
            >
              Update
            </button>
          ) : (
            <button
              disabled={checkValidation(formData)}
              onClick={() => {
                handleCloseModal()
                createNewIncident()
              }}
              className=" disabled:bg-gray1 bg-bluishGreen text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px]"
            >
              Create
            </button>
          )}
        </div>
      </Modal>
      <Modal
        customStyle={{ width: '480px' }}
        isOpen={isOpenInvite}
        onClose={() => setIsOpenInvite(false)}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsOpenInvite(false)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              {'Invite to Incident Report'}
            </h1>
          </div>
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
            <UiSelect
              onChange={(e) => {
                setUserId(e)
              }}
              // value={formData.status}
              options={userOptions || []}
              title={'User'}
              placeholder={'Select User'}
            />
          </div>
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
            <UiSelect
              disabled
              onChange={(e) => {
                setViewPermissions(e)
              }}
              value={viewPermission}
              options={[
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' },
              ]}
              title={'View Permission'}
              placeholder={'select'}
            />
          </div>
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
            <UiSelect
              onChange={(e) => {
                setEditPermissions(e)
              }}
              value={editPermission}
              options={[
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' },
              ]}
              title={'Edit Permission'}
              placeholder={'select'}
            />
          </div>
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
            <UiSelect
              onChange={(e) => {
                setDeletePermissions(e)
              }}
              value={deletePermission}
              options={[
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' },
              ]}
              title={'Delete Permission'}
              placeholder={'select'}
            />
          </div>

          {/* other information */}

          <button
            onClick={() => {
              createNewInnitation()
            }}
            className="bg-bluishGreen text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px]"
          >
            Invite
          </button>
        </div>
      </Modal>

      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 8px', width: '480px' }}
        isOpen={isExportOpen}
        onClose={handleExportCloseModal}
      >
        {isConfrim ? (
          <div
            className={
              'max-h-[100vh] overflow-scroll custom-scrollbar items-center flex flex-col gap-4 py-4 px-8'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-lg font-bold leading-6'}>
                Export Data
              </h1>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 text-center'
                }
              >
                The EXCEL 2007+ (xlsx) export file will be generated for
                download. Disable any popup blockers in your browser to ensure
                proper download. <span className="mt-3">Ok to proceed?</span>
              </p>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 mt-4 text-center'
                }
              >
                Ok to proceed?
              </p>
            </div>
            <div className="w-full flex flex-col gap-2 mt-2">
              <UIButton label="Confirm" onClick={() => {}} />
              <UIButton
                secondary
                label="Cancel"
                onClick={() => {
                  setIsConfrim(!isConfrim)
                }}
              />
            </div>
          </div>
        ) : (
          <div
            className={
              'max-h-[100vh] overflow-scroll custom-scrollbar items-center p-4 flex flex-col gap-4'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-[18px] font-bold'}>
                Export Data
              </h1>
              <p className={'text-[14px] text-text1 font-normal'}>
                Please choose the data you want to export and file type.
              </p>
            </div>
            <div className="w-[420px] flex-col flex gap-4 my-[15px]">
              <UiSelect
                title={'Select Export Columns'}
                placeholder="Please specify"
                options={[]}
                labelClass={'text-xs'}
                selectedOptionClass={
                  'text-sm font-semibold leading-6 text-text4'
                }
              />
              <UiSelect
                title={'Choose Filetype'}
                placeholder="Please specify"
                labelClass={'text-xs'}
                selectedOptionClass={
                  'text-sm font-semibold leading-6 text-text4'
                }
                options={[
                  {
                    value: 'html',
                    label: 'HTML',
                    iconName: 'IconGlobe',
                  },
                  {
                    value: 'csv',
                    label: 'CSV',
                    iconName: 'IconCodeSquare',
                  },
                  {
                    value: 'text',
                    label: 'Text',
                    iconName: 'IconFile',
                  },
                  {
                    value: 'excel95',
                    label: 'Excel 95 +',
                    iconName: 'IconBarChartCircle',
                  },
                  {
                    value: 'excel2007',
                    label: 'Excel 2007 +',
                    iconName: 'IconBarChartSquare',
                  },
                ]}
              />
            </div>
            <button
              onClick={() => setIsConfrim(!isConfrim)}
              className=" bg-bluishGreen text-white min-h-[48px] w-[98%] font-medium rounded-[72px] text-[14px]  "
            >
              Export Data
            </button>
          </div>
        )}
      </Modal>

      <Modal
        customStyle={{ width: '480px', borderRadius: 16 }}
        isOpen={isOpenDelete}
        onClose={handleCloseDeleteModal}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseDeleteModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Delete Incident Report
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Are you sure you want to delete this incident report?
            </p>
          </div>

          <button
            onClick={() => {
              removePolicy()
              setIsView(false)
            }}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Yes, I am Sure
          </button>
          <button
            onClick={handleCloseDeleteModal}
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Cancel
          </button>
        </div>
      </Modal>

      <Modal
        customStyle={{ borderRadius: 16 }}
        isOpen={isOpenStatus}
        onClose={handleStatusCloseModal}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] min-h-[46vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleStatusCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconMessageAlertSquare'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Change Report Status
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please specify the status of the report
            </p>
          </div>
          <div className="w-[416px] flex-col flex gap-4 mt-[10px]">
            <UiSelect
              onChange={(e) => {
                setStatus(e)
              }}
              value={status}
              options={[
                { value: 'open', label: 'open' },
                { value: 'closed', label: 'closed' },
              ]}
              title={'Status'}
            />
          </div>

          <button
            onClick={() => {
              handleStatusCloseModal()
              changeStatus()
            }}
            className=" bg-bluishGreen text-white min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Update
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default IncidentLead
